import { useLastPathSegment } from './useLastPathSegment'

export const useGetStep = <T extends string>(getSettingsStep: (path: T) => number) => {
  const lastPathSegment = useLastPathSegment() as T

  return getSettingsStep(lastPathSegment)
}
